import { Box } from "@mui/material";
import Icon from "@mui/material/Icon";

interface BoltPlusIconProps {
  size?: number;
}

const BoltPlusIcon = ({ size = 24 }: BoltPlusIconProps) => {
  const boltSize = Math.round(size * 0.85);
  const plusSize = Math.max(12, Math.round(size * 0.6));

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 1,
          top: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: boltSize,
          height: boltSize,
        }}
      >
        <Icon sx={{ fontSize: boltSize, color: "inherit" }}>bolt</Icon>
      </Box>
      <Icon
        sx={{
          position: "absolute",
          right: -1,
          bottom: -1,
          fontSize: plusSize,
          color: "inherit",
          textShadow: "0 0 2px rgba(0,0,0,0.35)",
        }}
      >
        add
      </Icon>
    </Box>
  );
};

export default BoltPlusIcon;
